var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.3,24H10.7l-.22-1.4a1.4,1.4,0,0,0-1.405-1.146,1.34,1.34,0,0,0-1.054.491L7.148,23,4.9,21.7l.484-1.292a1.348,1.348,0,0,0-.162-1.256,1.419,1.419,0,0,0-1.158-.623,1.343,1.343,0,0,0-.473.087L2.3,19.1,1,16.851l1.056-.869A1.414,1.414,0,0,0,1.4,13.524L0,13.3V10.7l1.4-.22A1.38,1.38,0,0,0,2.5,9.439a1.377,1.377,0,0,0-.444-1.421L1,7.148,2.3,4.9l1.292.484a1.348,1.348,0,0,0,.474.087A1.416,1.416,0,0,0,5.22,4.847,1.349,1.349,0,0,0,5.383,3.59L4.9,2.3,7.148,1l.869,1.056a1.336,1.336,0,0,0,1.051.491A1.407,1.407,0,0,0,10.476,1.4L10.7,0H13.3l.22,1.4A1.405,1.405,0,0,0,14.93,2.546a1.336,1.336,0,0,0,1.052-.491L16.851,1,19.1,2.3,18.617,3.59a1.349,1.349,0,0,0,.163,1.257,1.416,1.416,0,0,0,1.156.623,1.348,1.348,0,0,0,.474-.087L21.7,4.9,23,7.148l-1.056.869a1.415,1.415,0,0,0,.655,2.459l1.4.22V13.3l-1.4.22a1.414,1.414,0,0,0-.655,2.458L23,16.851,21.7,19.1l-1.292-.483a1.35,1.35,0,0,0-.475-.088,1.413,1.413,0,0,0-1.153.622,1.351,1.351,0,0,0-.164,1.258L19.1,21.7,16.851,23l-.869-1.056a1.335,1.335,0,0,0-1.05-.492A1.406,1.406,0,0,0,13.524,22.6L13.3,24ZM12,5a7,7,0,1,0,7,7A7.007,7.007,0,0,0,12,5Zm0,13a6,6,0,1,1,6-6A6.007,6.007,0,0,1,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Z",
    transform: "translate(-0.306)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.554317cdade7747c68a468c56445566a.svg";
export { ForwardRef as ReactComponent };